module.exports = __webpack_public_path__ + "media/07a_ASANBUDAPEST-Vibes09.0e76bc3f.mp3";